<section class="main-content">
  <div class="section-body">
      <!--First row-->
    <div class="row mt-4">
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card">
          <div class="card-statistic-4">
            <div class="align-items-center justify-content-between">
              <div class="row ">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                  <div class="card-content">
                    <h5 class="font-20">Planned Shows</h5>
                    <h2 class="mb-3 font-18">258</h2>
<!--                    <p class="mb-0"><span class="col-green">42%</span></p>-->
                  </div>
<!--                  <ngb-progressbar type="success" [value]="42" height=".3rem"></ngb-progressbar>-->
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                  <div class="banner-img">
                    <img src="assets/images/banner/t-show.png" alt="" style="height: 150px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card">
          <div class="card-statistic-4">
            <div class="align-items-center justify-content-between">
              <div class="row ">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                  <div class="card-content">
                    <h5 class="font-20"> Planned Jobs</h5>
                    <h2 class="mb-3 font-18">1,287</h2>
<!--                    <p class="mb-0"><span class="col-orange">33%</span></p>-->
                  </div>
<!--                  <ngb-progressbar type="warning" [value]="33" height=".3rem"></ngb-progressbar>-->
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                  <div class="banner-img">
                    <img src="assets/images/banner/t-s-job.png" alt="" style="height: 150px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card" style="min-height: 181px;">
          <div class="card-statistic-4">
            <div class="align-items-center justify-content-between">
              <div class="row ">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                  <div class="card-content">
                    <h5 class="font-20">Active Jobs</h5>
                    <h2 class="font-18 mb-1">128</h2>
                  <div><img src="assets/images/banner/job-types.png" alt="" style="width: 150px; height:30px;"></div>
<!--                    <p class="mb-0"><span class="col-blue">25%</span></p>-->

                  </div>
<!--                  <ngb-progressbar type="info" [value]="25" height=".3rem"></ngb-progressbar>-->
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                  <div class="banner-img">
<!--                    <img src="assets/images/banner/3.png" alt="">-->
                      <div echarts [options]="char1tOptions" class="demo-chart" style="height: 150px;padding:0;margin:0;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="card">
          <div class="card-statistic-4">
            <div class="align-items-center justify-content-between">
              <div class="row ">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                  <div class="card-content">
                    <h5 class="font-20">Estimates Lost</h5>
                    <h2 class="mb-3 font-18">23 - $48,697</h2>
                    <p class="mb-0"><span class="col-red">65%</span></p>
                  </div>
                  <ngb-progressbar type="danger" [value]="65" height=".3rem"></ngb-progressbar>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                  <div class="banner-img">
                    <img src="assets/images/banner/4.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!--Second row-->
      <div class="row mt-4">
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="card" style="min-height: 181px;">
                  <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                          <div class="row ">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                                  <div class="card-content">
                                      <h5 class="font-20">Jobs Added</h5>
                                      <h2 class="mb-5 font-18">74</h2>
                                      <div><img src="assets/images/banner/est-ord.png" alt="" style="width: 120px; height:30px;"></div>
                                      <!--                    <p class="mb-0"><span class="col-blue">25%</span></p>-->

                                  </div>
                                  <!--                  <ngb-progressbar type="info" [value]="25" height=".3rem"></ngb-progressbar>-->
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                                  <div class="banner-img">
                                      <!--                    <img src="assets/images/banner/3.png" alt="">-->
                                      <div echarts [options]="chart2Options" class="demo-chart" style="height: 150px;padding:0;margin:0;"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="card">
                  <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                          <div class="row ">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                                  <div class="card-content">
                                      <h5 class="font-20">Jobs with Estimators</h5>
                                      <h2 class="mb-3 font-18">58</h2>
                                      <!--                    <p class="mb-0"><span class="col-green">42%</span></p>-->
                                  </div>
                                  <!--                  <ngb-progressbar type="success" [value]="42" height=".3rem"></ngb-progressbar>-->
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                                  <div class="banner-img">
                                      <img src="assets/images/banner/job-estimation.png" alt="" style="height: 150px;">
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="card">
                  <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                          <div class="row ">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                                  <div class="card-content">
                                      <h5 class="font-20">Total Labor Hours</h5>
                                      <h2 class="mb-5 font-18">1,287</h2>
                                      <div><img src="assets/images/banner/planned-active.png" alt="" style="width: 130px; height:30px;"></div>
                                      <!--                    <p class="mb-0"><span class="col-orange">33%</span></p>-->
                                  </div>
                                  <!--                  <ngb-progressbar type="warning" [value]="33" height=".3rem"></ngb-progressbar>-->
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                                  <div class="banner-img">
                                      <div echarts [options]="chart3Options" class="demo-chart" style="height: 150px;padding:0;margin:0;"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="card">
                  <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                          <!--div class="row ">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 left-grid-spacing">
                                  <div class="card-content">
                                      <h5 class="font-20">City/Jobs</h5>
                                      <h2 class="mb-5 font-18">1,287</h2>
                                      <div><img src="assets/images/banner/planned-active.png" alt="" style="width: 130px; height:30px;"></div>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 right-grid-spacing">
                                  <div class="banner-img">
                                      <div echarts [options]="jobChartOptions" class="demo-chart" style="height: 150px;padding:0;margin:0;"></div>
                                  </div>
                              </div>
                          </div-->
                          <div class="row" style="height: 20px;">
                              <div class="col-4 pe-0" style="width:115px">
                                  <h5 class="font-20">City/Jobs</h5>
                              </div>
                              <div class="col-2 ps-0">
                                  <h2 class="mb-5 font-18">1,287</h2>
                              </div>
                              <div class="col-6 text-end">
                                  <img src="assets/images/banner/planned-active.png" alt="" style="width: 130px; height:30px;">
                              </div>
                          </div>

                          <div class="row" style="height: 130px;">
                              <div class="col-12">
                                  <div echarts [options]="jobChartOptions" class="demo-chart" style="height: 130px; padding:0; margin:0;"></div>
                                  <div class="d-flex justify-content-between px-2" style="font-size: 11px; margin-top: -8px;">
                                      <div>This Month</div>
                                      <div>Till Dec-2025</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- End of Second row-->

    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-6 ">
        <div class="card">
          <div class="card-header">
            <h4>Job Trends</h4>
          </div>
          <div class="card-body">
            <apx-chart [series]="lineChartOptions.series!" [chart]="lineChartOptions.chart!"
              [xaxis]="lineChartOptions.xaxis!" [stroke]="lineChartOptions.stroke!" [colors]="lineChartOptions.colors!"
              [dataLabels]="lineChartOptions.dataLabels!" [legend]="lineChartOptions.legend!"
              [tooltip]="lineChartOptions.tooltip!" [markers]="lineChartOptions.markers!"
              [grid]="lineChartOptions.grid!" [yaxis]="lineChartOptions.yaxis!" [title]="lineChartOptions.title!"
              [fill]="lineChartOptions.fill!">
            </apx-chart>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-6 ">
        <div class="card">
          <div class="card-header">
            <h4>Revenue Trends</h4>
          </div>
          <div class="card-body">
            <apx-chart [series]="barChartOptions.series!" [chart]="barChartOptions.chart!"
              [dataLabels]="barChartOptions.dataLabels!" [stroke]="barChartOptions.stroke!"
              [colors]="barChartOptions.colors!" [title]="barChartOptions.title!" [grid]="barChartOptions.grid!"
              [tooltip]="barChartOptions.tooltip!" [plotOptions]="barChartOptions.plotOptions!"
              [yaxis]="barChartOptions.yaxis!" [xaxis]="barChartOptions.xaxis!"></apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
